/**
 *  @class
 *  @function VerticalSlideshow
 */
if (!customElements.get('vertical-slideshow')) {
  class VerticalSlideshow extends HTMLElement {
    constructor() {
      super();
      let section = this;

      this.parent_section = this.closest('.shopify-section');
      this.slides = Array.from(section.querySelectorAll('.vertical-slideshow--slide'));
      this.dots = section.querySelector('.vertical-slideshow-dots');
      this.dots_li = this.dots?.querySelectorAll('li');
      this.animations = [];
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.setupScrolling.bind(this));
      } else {
        this.setupScrolling();
      }
    }
    setupScrolling() {
      const initScrollTrigger = () => {
        if (typeof ScrollTrigger !== 'undefined' && typeof gsap !== 'undefined' && this.slides.length > 0) {
          this.slides.forEach((slide, index) => {
            if (slide && slide.offsetHeight > 0) {
              ScrollTrigger.create({
                trigger: slide,
                start: 'top top',
                end: () => `+=${slide.offsetHeight}`,
                pin: true,
                pinSpacing: true,
                anticipatePin: 1
              });
            }
          });
          ScrollTrigger.refresh();
        }
      };

      if (typeof ScrollTrigger !== 'undefined' && typeof gsap !== 'undefined') {
        setTimeout(initScrollTrigger, 200);
      } else {
        setTimeout(() => {
          if (typeof ScrollTrigger !== 'undefined' && typeof gsap !== 'undefined') {
            initScrollTrigger();
          }
        }, 500);
      }

      let video_containers = [];
      this.slides.forEach(slide => {
        video_containers.push(slide.querySelector('.vertical-slideshow--slide-video-bg'));
      });

      window.addEventListener('scroll', () => {
        let top = this.getBoundingClientRect().top + window.scrollY;

        for (let i = 0; i < this.slides.length; ++i) {
          const slide = this.slides[i];

          if (window.scrollY <= slide.offsetTop && window.scrollY + window.innerHeight >= slide.offsetTop + slide.scrollHeight) {
            if (video_containers[i]) {
              this.videoPlay(video_containers[i]);
            }
            if (video_containers[i + 1]) {
              this.videoPause(video_containers[i + 1]);
            }
            if (video_containers[i - 1]) {
              this.videoPause(video_containers[i - 1]);
            }
            if (this.dots_li) {
              this.toggleDotClass(i);
            }
          }
        }

        if (window.scrollY > top + this.offsetHeight - 100) {
          this.videoPause(video_containers[this.slides.length - 1]);
        }
      }, {
        passive: true
      });

      setTimeout(() => {
        if (this.dots_li) {
          Array.from(this.dots_li).forEach((dot, index) => {
            dot.addEventListener('click', this.onDotClick.bind(this, dot, index));
          });
        }
      }, 10);
    }
    toggleDotClass(i) {
      [].forEach.call(this.dots_li, function (el) {
        el.classList.remove('is-selected');
      });
      this.dots_li[i].classList.add('is-selected');
    }
    onDotClick(dot, index) {

      let spacers = this.querySelectorAll('.pin-spacer'),
        top = spacers[index].getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: top,
        left: 0,
        behavior: "smooth"
      });
    }
    videoPause(video_container) {
      if (video_container && !video_container.querySelector('video').paused) {
        video_container.querySelector('video').pause();
      }
    }
    videoPlay(video_container) {
      if (video_container.querySelector('video').paused) {
        video_container.querySelector('video').play();
      }
    }
  }
  customElements.define('vertical-slideshow', VerticalSlideshow);
}
